import styled from 'styled-components';

import { Typography } from '../../shared/typography';

const Wrapper = styled.div`
	background-color: ${p => p.theme.colors.white};
	height: 100vh;
	width: 100vw;
	display: flex;
	flex-direction: row;
`;

const Left = styled.div`
	z-index: 2;
	height: 100%;
	width: 33vw;
	min-width: 500px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border: 1px solid #ccd2d9;

	@media (max-width: 1024px) {
		width: 100vw;
		min-width: 200px;
		justify-content: space-between;
	}
`;

const Top = styled.div`
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;

	@media (max-width: 1024px) {
		align-items: flex-start;
		/* flex: initial; */
	}
`;

const Logo = styled.img`
	height: 71px;

	@media (max-width: 1024px) {
		margin-top: 40px;
	}
`;

const Footer = styled.div`
	display: none;

	@media (max-width: 1024px) {
		display: flex;
	}
`;

const MobileLogo = styled.div`
	display: none;

	@media (max-width: 1024px) {
		display: block;
	}
`;

const Right = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: calc(100vw - 33vw);

	@media (max-width: 1024px) {
		display: none;
	}
`;

const LeftSide = styled.div`
	max-width: 440px;
	flex: 1;
	margin: 30px 40px;
`;

const BackgroundText = styled(Typography)`
	font-size: 52px;
	line-height: 62px;
	z-index: 2;
`;

const Gradient = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	width: calc(100vw - 50vw);
	height: 100%;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	Wrapper,
	Left,
	Right,
	Top,
	Logo,
	Footer,
	MobileLogo,
	LeftSide,
	BackgroundText,
	Gradient,
};
